import { FormulaType } from '../../constants/formulaType';

import { FormulaDetailModel } from '../../models/formula.model';
import { PushProviders } from '../../models/pushProvider.model';

export const getTestMessageIdFieldLabel = (
    providerName: PushProviders | undefined,
    formulaType: FormulaType | null | undefined,
    defaultLabel: string,
): string => {
    if (
        providerName === PushProviders.CleverTap &&
        formulaType === FormulaType.email
    ) {
        return 'user id';
    }
    return defaultLabel;
};

export const getDisableTestEmailMessage = (
    formulaType: FormulaType,
    formula: FormulaDetailModel,
) => {
    return {
        isDisable:
            formulaType === FormulaType.email &&
            !formula?.additional_metadata?.from_,
        message: `From field is required`,
    };
};
